import React, { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import ResultItem from './ResultItem';

const Results = ({ results, isModal }) => {
  const elementClass = isModal ? 'div.main-footer' : 'footer.main-footer';
  const element = document.querySelector(elementClass);
  const [resultsToAdd, setResultsToAdd] = useState(5);
  const button = useRef(null);
  const newResults = results.slice(0, resultsToAdd);

  const addMoreResults = () => {
    if (resultsToAdd >= results.length ) return;
    setResultsToAdd(resultsToAdd + 5);
  };

  const handleOnIntersect = entry => {
    if (entry[0].isIntersecting && button.current) {
      button.current.click();
    }
  };

  const createObserver = () => {
    const options = {
      root: null,
      treshold: 0,
      rootMargin: '-90% 0% -10%'
    };

    const observerCallback = new IntersectionObserver(
      entries => handleOnIntersect(entries),
      options
    );

    observerCallback.observe(element);
  };
  
  useEffect(() => {
    createObserver();
  }, []);

  return (
    <>
      <button ref={button} onClick={addMoreResults} hidden>
        add more
      </button>
      {newResults?.map((item, index) => (
        <div className="advanced-search__results-item" key={index}>
          <ResultItem item={item} />
        </div>
      ))}
    </>
  );
};

Results.propTypes = {
  results: PropTypes.array,
  isModal: PropTypes.string
};

export default Results;
